// extracted by mini-css-extract-plugin
module.exports = {"container":"hero_container___d2Wg","h1":"hero_h1__2zShM"};